import { SafeError, SafePromise } from '@benzinga/safe-await';
import { ExtendedListenableSubscribable } from '@benzinga/subscribable';
import { ConnatixLiveStreamResponse } from './entities';
import { LivestreamRestful } from './restful';
import { Session } from '@benzinga/session';

interface ErrorEvent {
  error?: SafeError;
  errorType: 'livestream:get_connatix_live_error';
  type: 'error';
}

interface LivestreamUpdateEvent {
  type: 'livestream:retrieving_connatix_live';
}

export type LivestreamRequestEvent = ErrorEvent | LivestreamUpdateEvent;

interface LivestreamFunctions {
  getConnatixLivestream: LivestreamRequest['getConnatixLivestream'];
}

export class LivestreamRequest extends ExtendedListenableSubscribable<LivestreamRequestEvent, LivestreamFunctions> {
  private restful: LivestreamRestful;

  constructor(session: Session) {
    super();
    this.restful = new LivestreamRestful(session);
  }

  public getConnatixLivestream = async (): SafePromise<ConnatixLiveStreamResponse | undefined> => {
    this.dispatch({
      type: 'livestream:retrieving_connatix_live',
    });
    const res = await this.restful.getConnatixLivestream();
    if (res.err) {
      this.dispatch({
        error: res.err,
        errorType: 'livestream:get_connatix_live_error',
        type: 'error',
      });
    }
    return { ok: res.ok };
  };

  protected onSubscribe(): LivestreamFunctions {
    return {
      getConnatixLivestream: this.getConnatixLivestream,
    };
  }
}
